import { ApplicationState } from '../reducers';

export const selectCallDetails = (state: ApplicationState) => state.callDetails;
